webpackJsonp([21288892715627],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  padding-top: ', ';\n'], ['\n  font-size: ', ';\n  padding-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  padding-top: ', ';\n  padding-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  padding-top: ', ';\n  padding-bottom: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _getJobUrl = __webpack_require__(173);
	
	var _Link = __webpack_require__(28);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _JobDates = __webpack_require__(171);
	
	var _JobDates2 = _interopRequireDefault(_JobDates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H3 = _styledComponents2.default.h3(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(3);
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(-4);
	});
	
	var Li = _styledComponents2.default.li(_templateObject2, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(0);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(0);
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(0);
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.scale(0);
	});
	
	var JobsAndClients = function JobsAndClients(props) {
	  var url = (0, _getJobUrl.getJobUrl)(props.intl.locale, props.slug);
	
	  return _react2.default.createElement(
	    Li,
	    null,
	    _react2.default.createElement(
	      _Link2.default,
	      { to: url },
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_JobDates2.default, props.date),
	          _react2.default.createElement(
	            H3,
	            null,
	            props.name
	          )
	        )
	      )
	    )
	  );
	};
	
	JobsAndClients.propTypes = {
	  date: _propTypes2.default.object.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  slug: _propTypes2.default.string.isRequired,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(JobsAndClients);
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	var _reactIntl = __webpack_require__(7);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _JobsAndClient = __webpack_require__(125);
	
	var _JobsAndClient2 = _interopRequireDefault(_JobsAndClient);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsAndClientsPage = function JobsAndClientsPage(props) {
	  var _props$data$site$site = props.data.site.siteMetadata.resume,
	      menu = _props$data$site$site.menu,
	      jobsAndClients = _props$data$site$site.jobsAndClients;
	
	
	  return _react2.default.createElement(
	    _ResumeContainer2.default,
	    {
	      menu: menu,
	      selectedPage: '/resume/jobs-and-clients/'
	    },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'resume.jobsAndClients' },
	      function (txt) {
	        return _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_reactHelmet2.default, {
	            title: txt,
	            meta: [{ name: 'description', content: txt }]
	          }),
	          _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      jobsAndClients.map(function (job) {
	        return _react2.default.createElement(_JobsAndClient2.default, job);
	      })
	    )
	  );
	};
	
	JobsAndClientsPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = JobsAndClientsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JobsAndClientsPage = __webpack_require__(126);
	
	var _JobsAndClientsPage2 = _interopRequireDefault(_JobsAndClientsPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_JobsAndClientsPage2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-jobs-and-clients-index-fr-js-a23fe2b75cdcff0e1e4a.js